import { T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS } from './TYPES'

const DE_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS: T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS =
  {
    TITLE: 'Testzeitraum',
    DESCRIPTION:
      'Dein Testzeitraum endet am {subscriptionExpireOn}. Bitte kontaktiere einen Erwachsenen, um dein Abonnement zu verlängern.',
    CTA_TEXT: 'Schließen'
  }

export default DE_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS
